module.exports = __webpack_public_path__ + "static/media/BT_deck.9dea0cda.key";